import { push } from "connected-react-router";

import { BASE_URL } from "config";
import { api } from "utils";
import * as base from '../base';


const endpoints = {
  list: `${BASE_URL}/api/v1/seo/extdomain/`,
  detail: (id) => `${BASE_URL}/api/v1/seo/extdomain/${id}/`,

};

export const seoExtDomainListLoad = (token, payload) => api.ListLoad(endpoints.list, token, payload);
export const seoExtDomainDetailLoad = (token, { id }) => api.DetailLoad(endpoints.detail, token, { id });
export const seoExtDomainUpdate = (token, data) => api.Update(endpoints.list, endpoints.detail, token, data);
export const seoExtDomainDelete = (token, data) => api.Delete(endpoints.detail, token, data);


export const seoExtDomain = {
  state: {
    ...base.ListState,
    ...base.DetailState,
    ...base.EditState,
    ...base.DeleteState,

    title: 'Внешние ссылки: домены',
    urls: {
      list: () => `/extlink`,
      detail: (id) => `/extlink/${id}`,
    },
  },
  reducers: {
    ...base.ListReducers,
    ...base.DetailReducers,
    ...base.EditReducers,
    ...base.DeleteReducers,
  },
  effects: dispatch => ({
    async listLoad(payload, rootState) {
      await base.asyncListLoadRequest(dispatch, payload, rootState, 'seoExtDomain', seoExtDomainListLoad)
    },

    async detailLoad(payload, rootState) {
      await base.asyncDetailLoadRequest(dispatch, payload, rootState, 'seoExtDomain', seoExtDomainDetailLoad)
    },

    async update(payload, rootState) {
      await base.asyncUpdateRequest(dispatch, payload, rootState, 'seoExtDomain', seoExtDomainUpdate,
        async (data) => {
          dispatch['seoExtDomain'].showEditForm({ show: false });
          const filter = rootState['seoExtDomain'].filter;
          await dispatch['seoExtDomain'].listLoad(filter);
          const filter2 = rootState['seoExtLink'].filter;
          await dispatch['seoExtLink'].listLoad(filter2);
        }
      );
    },

    async delete(payload, rootState) {
      await base.asyncDeleteRequest(dispatch, payload, rootState, 'seoExtDomain', seoExtDomainDelete,
        async (data) => {
          dispatch(push(rootState['seoExtDomain'].urls.list(data.site, data.type)));
          const filter = rootState['seoExtDomain'].filter;
          await dispatch['seoExtDomain'].listLoad(filter);
        }
      );
    },
  }),
}